const lesson2_1 = {
  id: '2.1',
  chapterId: 2,
  lessonId: 1,

  title: 'Ce este factura si cand se utilizeaza',
  duration: 8,

  steps: [
    {
      id: 1,

      left: {
        type: 'theory',
        eyebrow: 'FACTURA',
        title: 'Ce este factura?',
        content: [
          '<p>🧾 <b>Factura</b> este un document utilizat pentru a descrie o vanzare de bunuri sau servicii intre doua parti.</p>',
          '<p>Prin factura putem identifica <b>cine vinde</b>, <b>cine cumpara</b>, ce bunuri sau servicii sunt facturate si care este valoarea acestora.</p>',
          '<p>In exemplul din dreapta, <b>ALFA SRL</b> vinde produse catre <b>NOVA SRL</b>. Analizeaza documentul si observa unde apar aceste informatii.</p>'
        ]
      },

      right: {
        type: 'invoiceDocument',
        header: 'Analizeaza factura',

        invoice: {
          series: 'CL',
          number: '000124',
          date: '06.09.2026',
          dueDate: '21.09.2026',

          supplier: {
            name: 'ALFA SRL',
            cui: 'RO12345678',
            regCom: 'J12/1234/2020',
            address: 'Cluj-Napoca, Str. Fabricii nr. 10',
            iban: 'RO49AAAA1B31007593840000'
          },

          customer: {
            name: 'NOVA SRL',
            cui: 'RO87654321',
            regCom: 'J12/5678/2021',
            address: 'Cluj-Napoca, Str. Memorandumului nr. 20'
          },

          items: [
            {
              id: 1,
              name: 'Hartie copiator A4',
              quantity: 10,
              unit: 'buc',
              unitPrice: 25,
              vatRate: 21
            },
            {
              id: 2,
              name: 'Dosare arhivare',
              quantity: 20,
              unit: 'buc',
              unitPrice: 10,
              vatRate: 21
            }
          ],

          subtotal: 450,
          vat: 94.5,
          total: 544.5,

          currency: 'RON'
        }
      }
    },

    {
      id: 2,

      left: {
        type: 'situation',
        eyebrow: 'OBSERVA DOCUMENTUL',
        title: 'Cine vinde si cine cumpara?',
        content: [
          '<p>🏢 Pe o factura exista doua parti principale: <b>furnizorul</b> si <b>clientul</b>.</p>',
          '<p><b>Furnizorul</b> este firma care vinde bunurile sau serviciile, iar <b>clientul</b> este firma care le cumpara.</p>',
          '<p>Foloseste factura din dreapta pentru a identifica rolul fiecarei firme.</p>'
        ]
      },

      right: {
        type: 'invoiceIdentifyParties',
        header: 'Identifica partile',

        invoiceRef: 'current',

        question: 'Ce rol are ALFA SRL in aceasta operatiune?',

        options: [
          'Clientul care cumpara produsele',
          'Furnizorul care vinde produsele',
          'Banca prin care se face plata'
        ],

        correctAnswer: 'Furnizorul care vinde produsele',

        explanation:
          '<p>✅ <b>ALFA SRL</b> este furnizorul deoarece aceasta firma vinde produsele catre NOVA SRL.</p>'
      }
    },

    {
      id: 3,

      left: {
        type: 'situation',
        eyebrow: 'CITESTE FACTURA',
        title: 'Gaseste informatia corecta',
        content: [
          '<p>🔎 O factura trebuie sa permita identificarea rapida a informatiilor despre tranzactie.</p>',
          '<p>Nu este suficient sa stii definitia facturii. In practica trebuie sa poti <b>gasi si interpreta informatiile</b> din document.</p>'
        ]
      },

      right: {
        type: 'invoiceFieldQuiz',
        header: 'Lucreaza pe factura',

        invoiceRef: 'current',

        question: 'Care este valoarea totala de plata a facturii?',

        options: [
          '450,00 RON',
          '94,50 RON',
          '544,50 RON'
        ],

        correctAnswer: '544,50 RON',

        highlightAfterAnswer: 'total',

        explanation:
          '<p>💡 Valoarea de <b>544,50 RON</b> reprezinta totalul facturii.</p>'
      }
    }
  ]
};

export default lesson2_1;